// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M17.707 4.293l-4-4A.997.997 0 0013 0H3a1 1 0 00-1 1v18a1 1 0 001 1h14a1 1 0 001-1V5a.997.997 0 00-.293-.707zM16 18H4V2h8.586L16 5.414V18zm-3-5H7a1 1 0 000 2h6a1 1 0 000-2m-7-3a1 1 0 001 1h6a1 1 0 000-2H7a1 1 0 00-1 1m1-3h1a1 1 0 000-2H7a1 1 0 000 2\"/></svg>";
// Exports
module.exports = code;